import { Link } from "react-router-dom";
import { Car, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

const MobileCTA = () => (
  <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-background/90 backdrop-blur-xl border-t border-border/50 px-4 py-3 safe-area-bottom">
    <div className="flex gap-3">
      <Button asChild variant="outline" className="flex-1 h-11 text-sm">
        <Link to="/rideshare">
          <Car className="mr-2 h-4 w-4" /> Rideshare
        </Link>
      </Button>
      <Button asChild className="flex-1 h-11 text-sm glow">
        <Link to="/#booking">
          <Calendar className="mr-2 h-4 w-4" /> Book Now
        </Link>
      </Button>
    </div>
  </div>
);

export default MobileCTA;
